import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { ContactSelect, HeroSelect } from '../Main';
import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';
import {
  PurchaseDomainDialog,
} from '../Dialogs';
import { startEditWebsiteRoot } from 'store/actions/website';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  butterflyAbout: {
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    margin: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    marginBottom: theme.spacing.unit*2,
    flexGrow: 1,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
    backgroundColor: '#fff',
    borderRadius: '5px',
  }
});

class Main extends Component {
  constructor(props){
    super(props);
    this.state ={
      showDialog: false,
    };
  }

  render() {
    const {
      classes,
      websiteRoot,
      orgDomain,
      showValidation,
      validation,
      onDataChange,
      startEditWebsiteRoot,
      help
    } = this.props;
    const { showDialog } = this.state;

    return(
      <div className={classes.root}>
        <PurchaseDomainDialog
          showDialog={showDialog}
          handleClose={() => this.setState({ showDialog: false })}
        />
        <Card className={classes.card}>
          <CardHeader
            title="Website Header"
            subheader="Here are all the basic parts to get your website started."
          />
          <CardContent className={classes.cardContent}>
            <div className={classes.column}>
              <Tooltip type={TooltipTypes.website.SELECT_THEME} placement="right">
                <FormControl
                  error={ showValidation ? !!validation.validateField("theme") : false }
                  className={classNames(classes.textField, help.isCurrentStep(TooltipTypes.website.SELECT_THEME) && classes.elevate)}
                >
                  <InputLabel shrink htmlFor="theme">Theme</InputLabel>
                  <Select
                    value={websiteRoot.theme ? websiteRoot.theme : ""}
                    onChange={event => {
                      onDataChange();
                      helpDispatch(TooltipTypes.website.SELECT_THEME);
                      startEditWebsiteRoot({theme: event.target.value});
                    }}
                    inputProps={{
                      name: 'theme',
                      id: 'theme',
                    }}
                  >
                    <MenuItem value={"knight"}>Knight</MenuItem>
                    <MenuItem value={"butterfly"}>Butterfly</MenuItem>
                    <MenuItem value={"vlava"}>Vlava</MenuItem>
                  </Select>
                  {showValidation && validation.validateField("theme") &&
                    <FormHelperText>{validation.validateField("theme")}</FormHelperText>
                  }
                </FormControl>
              </Tooltip>
              {false &&
                <TextField
                  error={(showValidation && !!validation.validateField("domain"))}
                  helperText={(showValidation && validation.validateField("domain"))}
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  label="Domain"
                  margin="none"
                  value={websiteRoot.domain}
                  onChange={(event) => {
                    onDataChange();
                    startEditWebsiteRoot({domain: event.target.value});
                  }}
                />
              }
              {false &&
                <div style={{ display: 'flex', flexDirection: 'row'}}>
                  <TextField
                    error={(showValidation && !!validation.validateField("subDomain"))}
                    helperText={(showValidation && validation.validateField("subDomain"))}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    label="Subdomain"
                    margin="none"
                    value={websiteRoot.subDomain}
                    onChange={(event) => {
                      onDataChange();
                      startEditWebsiteRoot({subDomain: event.target.value});
                    }}
                  />
                  <div>{orgDomain.subDomainStatus}</div>
                </div>
              }
              {false &&
              <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <TextField
                    disabled
                    error={(showValidation && !!validation.validateField("customDomain"))}
                    helperText={(showValidation && validation.validateField("customDomain"))}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    label="Custom Domain"
                    margin="none"
                    value={websiteRoot.customDomain}
                    onChange={(event) => {
                      onDataChange();
                      startEditWebsiteRoot({customDomain: event.target.value});
                    }}
                  />
                  <div>{orgDomain.customDomainStatus}</div>
                </div>
                <Button
                  style={{ marginBottom: '5px' }}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    this.setState({ showDialog: true });
                  }}
                >Purchase</Button>
              </div>
              }
              <Tooltip type={TooltipTypes.website.HEADER_INFO_AREA} placement="top">
                <div />
              </Tooltip>
              <Tooltip type={TooltipTypes.website.BASIC_INFO} placement="right">
                <div className={help.isCurrentStep(TooltipTypes.website.BASIC_INFO) && classes.elevate} style={{ display: 'flex', flexDirection: 'column' }}>
                  <TextField
                    error={(showValidation && !!validation.validateField("companyName"))}
                    helperText={(showValidation && validation.validateField("companyName"))}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    label="Company Name"
                    margin="none"
                    value={websiteRoot.companyName}
                    onChange={(event) => {
                      onDataChange();
                      startEditWebsiteRoot({companyName: event.target.value});
                    }}
                  />
                  <TextField
                    error={(showValidation && !!validation.validateField("phone"))}
                    helperText={(showValidation && validation.validateField("phone"))}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    label="Phone"
                    margin="none"
                    value={websiteRoot.phone}
                    onChange={(event) => {
                      onDataChange();
                      startEditWebsiteRoot({phone: event.target.value});
                    }}
                  />
                  {websiteRoot.theme === "butterfly" &&
                    <TextField
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      label="Heading"
                      margin="none"
                      value={websiteRoot.heading}
                      onChange={(event) => {
                        onDataChange();
                        startEditWebsiteRoot({heading: event.target.value});
                      }}
                    />
                  }
                  <TextField
                    error={(showValidation && !!validation.validateField("tagline"))}
                    helperText={(showValidation && validation.validateField("tagline"))}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    label="Tagline"
                    margin="none"
                    value={websiteRoot.tagline}
                    onChange={(event) => {
                      onDataChange();
                      startEditWebsiteRoot({tagline: event.target.value});
                    }}
                  />
                </div>
              </Tooltip>
            </div>
            { websiteRoot.theme === "vlava" &&
              <HeroSelect initialFilename={websiteRoot.heroImage} />
            }

          </CardContent>
        </Card>
          <Card className={classes.card}>
            <CardHeader
              title="Contact"
              subheader="This contains your contact information and working area."
            />
            <CardContent className={classes.cardContent}>
              <div className={classes.column}>
                <TextField
                  error={(showValidation && !!validation.validateField("contactName"))}
                  helperText={(showValidation && validation.validateField("contactName"))}
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  label="Contact Name"
                  margin="none"
                  value={websiteRoot.contactName}
                  onChange={(event) => {
                    onDataChange();
                    startEditWebsiteRoot({contactName: event.target.value});
                  }}
                />
                <TextField
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  label="Location (optional)"
                  margin="none"
                  value={websiteRoot.location}
                  onChange={(event) => {
                    onDataChange();
                    startEditWebsiteRoot({location: event.target.value});
                  }}
                />
                <TextField
                  error={(showValidation && !!validation.validateField("email"))}
                  helperText={(showValidation && validation.validateField("email"))}
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  label="Email"
                  margin="none"
                  value={websiteRoot.email}
                  onChange={(event) => {
                    onDataChange();
                    startEditWebsiteRoot({email: event.target.value});
                  }}
                />
                {websiteRoot.theme === "butterfly" &&
                  <div className={classes.butterflyAbout}>
                    <TextField
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      label="Title"
                      margin="none"
                      value={websiteRoot.contactTitle}
                      onChange={(event) => {
                        onDataChange();
                        startEditWebsiteRoot({contactTitle: event.target.value});
                      }}
                    />
                    <TextField
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      multiline
                      rowsMax="5"
                      label="About"
                      margin="none"
                      value={websiteRoot.contactAbout}
                      onChange={(event) => {
                        onDataChange();
                        startEditWebsiteRoot({contactAbout: event.target.value});
                      }}
                    />
                  </div>
                  }
              </div>
              {false &&
                <ContactSelect initialFilename={websiteRoot.contactImage} />
              }
            </CardContent>
          </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { website: websiteValidation } = state.validation;
  const organization = state.accountState.organizations[0];
  const oid = organization ? organization.id : undefined;
  const orgDomains = state.orgDomains;
  let orgDomain = {};
  orgDomains.forEach(item => {
    if (oid && item.oid === oid) {
      orgDomain = item;
    }
  });

  let validation = {};
  if (websiteValidation && websiteValidation.root) {
    validation = websiteValidation.root;
  }

  return({
    websiteRoot: state.websiteState.root,
    validation,
    help: state.help,
    orgDomain,
  });
};


const mapDispatchToProps = {
  startEditWebsiteRoot,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Main);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Main/Main.jsx